module.exports = __webpack_public_path__ + "static/media/r104.af502749.jpg";